import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';
import { Mortgage } from '@/reactPages/Mortgage';

export const meta = {
  title: 'Ипотека на сахалине',
};

const MortgagePage = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <Mortgage></Mortgage>
    </>
  );
};

export default MortgagePage;
